import React, { Fragment, useMemo } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { format } from "date-fns";
import { useParams } from "react-router-dom";
import PageHeading from "Layout/AppMain/PageHeading";
import UsersTable from "./RecordsTable";
import { useSubRequests } from "Api/Melder/Search";


const Default = () => {
    const params = useParams();
    const substitute = params.substitute || "";

    const { data: usersResponse, isLoading, error } = useSubRequests(substitute);

    // const userdata = useMemo(() => {
    //     return (
    //         usersResponse?.data.data?.map((element) => ({
    //             ...element,
    //             FirstDate: element.FirstDate
    //                 ? format(new Date(element.FirstDate), "dd-MM-yyyy")
    //                 : "",
    //             LastDate: element.LastDate
    //                 ? format(new Date(element.LastDate), "dd-MM-yyyy")
    //                 : "",
    //         })) || []
    //     );
    // }, [usersResponse]);

   
const userdata = useMemo(() => {
    return (
        usersResponse?.data?.map((element) => {

            const firstDate = new Date(element.FirstDate);
            const lastDate = new Date(element.LastDate);

            return {
                ...element,
                FirstDate:
                    !isNaN(firstDate.getTime())
                        ? format(firstDate, "dd-MM-yyyy")
                        : "",
                LastDate:
                    !isNaN(lastDate.getTime())
                        ? format(lastDate, "dd-MM-yyyy")
                        : "",
            };
        }) || []
    );
}, [usersResponse]);


    return (
        <Fragment>
            <PageHeading />
            <TransitionOnLoad>
                <div>
                    <Row>
                        <Col md="12">
                            <Card className="main-card mb-3">
                                <CardBody className="p-3">
                                    {userdata.length > 0 ? (
                                        <UsersTable data={userdata} />
                                    ) : (
                                        <div className="text-center">
                                            Geen gegevens beschikbaar
                                        </div>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </TransitionOnLoad>
        </Fragment>
    );
};

export default Default;

